// extracted by mini-css-extract-plugin
export default {"container":"TabSelector_container__2DvKU","tab":"TabSelector_tab__lC51G","tabSelected":"TabSelector_tabSelected__9i2ep","yellow":"TabSelector_yellow__HEi1z"};